export function Card({ className = "", children }) {
  return (
    <div
      className={`rounded-2xl border border-dulia-line bg-dulia-panel text-dulia-ink shadow-soft dark:border-dulia-lineStrong/30 dark:bg-dulia-nightSoft dark:text-dulia-parchment ${className}`}
    >
      {children}
    </div>
  );
}

export function CardHeader({ className = "", children }) {
  return (
    <div
      className={`border-b border-dulia-line bg-dulia-parchment/55 px-4 py-3 dark:border-dulia-lineStrong/30 dark:bg-dulia-night ${className}`}
    >
      {children}
    </div>
  );
}

export function CardBody({ className = "", children }) {
  return <div className={`p-4 ${className}`}>{children}</div>;
}